export default "__VITE_ASSET__lrW8BBcd__"